export const isDeliveryNeeded = ({
    isSimOnly,
    isShippingSimRequired,
    isHwOnly,
    isHwOnlyBankid,
}: {
    isHwOnly: boolean;
    isHwOnlyBankid: boolean;
    isShippingSimRequired: boolean;
    isSimOnly: boolean;
}): boolean => {
    if (isHwOnly && !isHwOnlyBankid) {
        return false;
    }

    if (!isSimOnly) {
        return true;
    }

    return isShippingSimRequired;
};
